var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import store from "../../reduxStore/store";
import { isLoading, salesOrderSearchText } from "../../services/behaviorSubjectService";
import { deleteInvoiceData, draftOrderDetails, applyStReportsFromOrdersCache, getSalesRepSTReports, refundOrderData, restoreStReportsFromDefault, sendInvoiceData, } from "../../reduxStore/actions/salesRepDataAction";
import { EDIT_ORDER_FLAG } from "../Constant";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { handleMenuClick as sharedHandleMenuClick, handleMenuClose, handleSendInvoice as sharedHandleSendInvoice, handlePrintFromMenu as sharedHandlePrintFromMenu, handlePrintInvoiceClick, buildPrintInvoicesBySalesRepUrl, handleDuplicateOrder as sharedHandleDuplicateOrder, calculateB2BTabIndex, handleDuplicateOrderFromDialog, handlePrintFromDialog, } from "./SalesOrderDetailsSharedBL";
import { loadMergedOrderRowDetails, getStandardOrderMoreActionsMode, OrderRowDetailKind, StandardOrderMoreActionsMode, } from "./AllOrdersOrderDetailDialogs";
import { formatDateForAPI } from "./STReports/DateRangePicker/DateRangePickerBL";
import { parseDisplayDateValue } from "../SharedFunctions";
import { logClientRuntimeError } from "../../services/clientErrorLog";
import { mapStReportApiRowToLegacyCommission } from "../../services/stReportUnifiedOrderMapper";
import { createSTOrderDetailsInitialTabPages, clampSTOrderDetailsPageIndex, getSTOrderDetailsTabSlicesFromPayload, getSTOrderDetailsOrdersForUiTab, getSTOrderDetailsTotalCountForUiTab, hasInMemorySTOrderDetailsSliceForView, isSTOrderDetailsSliceCachedForPage, isSTOrderDetailsActiveTabEmpty, isSTOrderDetailsDefaultDateRange, isNoDataForSTOrderDetailsAppliedRange, ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE, ST_ORDER_DETAILS_ROWS_PER_PAGE_OPTIONS, ST_ORDER_DETAILS_SEARCH_DEBOUNCE_MS, buildSTOrderDetailsSearchQueryParam, } from "../model/STOrderDetailsModel";
import { buildSTReportsOrdersCacheRangeKey, getSTReportsDisplayPayloadFromCache, hasSTReportsExactRangeCacheAuthority, } from "../../reduxStore/stReportsOrdersCache";
import { getSTOrderDetailsRefundRowsForUiTab, resolveRefundOrderDetailRequestParams } from "../model/stOrderDetailsRefundGrid";
/** Reads `TotalSubtotal` / `TotalCommission` from API (numbers or numeric strings). */
function readSTOrderDetailsServerTotal() {
    var candidates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        candidates[_i] = arguments[_i];
    }
    for (var _a = 0, candidates_1 = candidates; _a < candidates_1.length; _a++) {
        var v = candidates_1[_a];
        if (v == null || v === "") {
            continue;
        }
        if (typeof v === "number" && Number.isFinite(v)) {
            return v;
        }
        if (typeof v === "string") {
            var n = Number(String(v).replace(/,/g, "").trim());
            if (Number.isFinite(n)) {
                return n;
            }
        }
    }
    return null;
}
export { ST_ORDER_DETAILS_ROWS_PER_PAGE_OPTIONS } from "../model/STOrderDetailsModel";
export function OrdersTableBL(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16;
    var t = useTranslation().t;
    var shopCurrency = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.shopCurrency) !== null && _c !== void 0 ? _c : ""; });
    var shopName = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.shopName) !== null && _c !== void 0 ? _c : ""; });
    var selectFeatures = useSelector(function (state) { var _a, _b, _c; return ((_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.select) !== null && _c !== void 0 ? _c : {}); });
    var ordersData = useSelector(function (state) { var _a; return (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.ordersData; });
    var stReportsData = useSelector(function (state) { var _a; return (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsData; });
    var stReportsOrdersByDateRange = useSelector(function (state) { var _a; return (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsOrdersByDateRange; });
    var stReportsDefaultData = useSelector(function (state) { var _a; return (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsDefaultData; });
    var currency = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.currency) !== null && _c !== void 0 ? _c : ""; });
    /** Prior page rows for the same date/search/tab — used only during pagination loading. */
    var _17 = useState(null), stReportsPaginationSnapshot = _17[0], setStReportsPaginationSnapshot = _17[1];
    /** Last committed search response — keeps grid visible during filtered pagination loads. */
    var _18 = useState(null), stReportsSearchSnapshot = _18[0], setStReportsSearchSnapshot = _18[1];
    var _19 = useState([]), orders = _19[0], setOrders = _19[1];
    var _20 = useState([]), filtered = _20[0], setFiltered = _20[1];
    var _21 = useState(!((ordersData === null || ordersData === void 0 ? void 0 : ordersData.isPaidUnPaidOrdersLoaded) && (ordersData === null || ordersData === void 0 ? void 0 : ordersData.isDraftOrdersLoaded))), orderesLoading = _21[0], setOrdersLoading = _21[1];
    var _22 = useState(""), searchAllOrderText = _22[0], setSearchAllOrderText = _22[1];
    var _23 = useState(""), searchInputText = _23[0], setSearchInputText = _23[1];
    var _24 = useState(""), debouncedSearchQuery = _24[0], setDebouncedSearchQuery = _24[1];
    var _25 = useState(false), openPrintInvoiceDialog = _25[0], setOpenPrintInvoiceDialog = _25[1];
    var _26 = useState(null), printInvoiceData = _26[0], setPrintInvoiceData = _26[1];
    var _27 = useState(null), menuAnchorEl = _27[0], setMenuAnchorEl = _27[1];
    var _28 = useState(null), selectedOrder = _28[0], setSelectedOrder = _28[1];
    var _29 = useState(false), deleteConfirmation = _29[0], setDeleteConfirmation = _29[1];
    var _30 = useState(false), deleteInvoiceFlag = _30[0], setDeleteInvoiceFlag = _30[1];
    var _31 = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _31[0], setAlertErrorMsg = _31[1];
    var _32 = useState(null), allOrdersDetailKind = _32[0], setAllOrdersDetailKind = _32[1];
    var _33 = useState([]), allOrdersStandardProducts = _33[0], setAllOrdersStandardProducts = _33[1];
    var _34 = useState(null), allOrdersStandardClient = _34[0], setAllOrdersStandardClient = _34[1];
    var _35 = useState([]), allOrdersDraftProducts = _35[0], setAllOrdersDraftProducts = _35[1];
    var _36 = useState(null), allOrdersDraftClient = _36[0], setAllOrdersDraftClient = _36[1];
    var _37 = useState([]), allOrdersRefundProducts = _37[0], setAllOrdersRefundProducts = _37[1];
    var _38 = useState(null), allOrdersStandardSourceRow = _38[0], setAllOrdersStandardSourceRow = _38[1];
    var _39 = useState(null), allOrdersDraftSourceRow = _39[0], setAllOrdersDraftSourceRow = _39[1];
    var _40 = useState(createSTOrderDetailsInitialTabPages), pageByTab = _40[0], setPageByTab = _40[1];
    var _41 = useState(ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE), STOrderDetailsRowsPerPage = _41[0], setSTOrderDetailsRowsPerPage = _41[1];
    /** Set only when a tab page is not in cache — triggers a tab-specific server fetch (not tab switches). */
    var _42 = useState(null), serverPaginationFetch = _42[0], setServerPaginationFetch = _42[1];
    /** Bumps when a tab switch finds no range cache so the fetch effect runs one bulk `All` request. */
    var _43 = useState(0), rangeFetchRevision = _43[0], setRangeFetchRevision = _43[1];
    var _44 = useState("idle"), loadingPhase = _44[0], setLoadingPhase = _44[1];
    var lastFetchedSearchRef = useRef(null);
    var lastFetchSignatureRef = useRef(null);
    var fetchInFlightSignatureRef = useRef(null);
    var lastFetchedPagesRef = useRef(createSTOrderDetailsInitialTabPages());
    var lastFetchedPageSizeRef = useRef(ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE);
    var lastFetchedDateKeyRef = useRef("");
    var lastFetchedListTabRef = useRef("All");
    /** True while Redux still holds rows from a search response — block serving until range cache/API restores. */
    var lastFetchedHadSearchRef = useRef(false);
    var lastKnownTotalByTabRef = useRef({});
    var dispatch = useDispatch();
    useEffect(function () {
        var sub = isLoading.subscribe(function (active) {
            setLoadingPhase(function (prev) {
                if (active) {
                    return "global";
                }
                return prev === "global" ? "idle" : prev;
            });
        });
        return function () { return sub.unsubscribe(); };
    }, []);
    var stOrderDetailsTableLoading = loadingPhase === "table" || loadingPhase === "global";
    var showStOrderDetailsTableLoader = loadingPhase === "table";
    var setStOrderDetailsTableLoading = function (active) {
        setLoadingPhase(function (prev) {
            if (prev === "global") {
                return prev;
            }
            return active ? "table" : "idle";
        });
    };
    var allOrdersStandardMoreActionsMode = useMemo(function () {
        if (allOrdersDetailKind !== OrderRowDetailKind.Standard || !allOrdersStandardSourceRow) {
            return StandardOrderMoreActionsMode.None;
        }
        return getStandardOrderMoreActionsMode(allOrdersStandardSourceRow);
    }, [allOrdersDetailKind, allOrdersStandardSourceRow]);
    var handleAlertMsgClose = function () {
        setAlertErrorMsg({ msg: "", open: false });
    };
    var closeAllOrdersDetailDialogs = function () {
        setAllOrdersDetailKind(null);
        setAllOrdersStandardProducts([]);
        setAllOrdersStandardClient(null);
        setAllOrdersStandardSourceRow(null);
        setAllOrdersDraftProducts([]);
        setAllOrdersDraftClient(null);
        setAllOrdersDraftSourceRow(null);
        setAllOrdersRefundProducts([]);
        isLoading.next(false);
        setStOrderDetailsTableLoading(false);
    };
    var handleAllOrdersStandardDuplicate = function () { return __awaiter(_this, void 0, void 0, function () {
        var client, row, orderId, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    client = allOrdersStandardClient;
                    row = allOrdersStandardSourceRow;
                    if (!client) {
                        return [2 /*return*/];
                    }
                    orderId = (_b = (_a = row === null || row === void 0 ? void 0 : row.OrderId) !== null && _a !== void 0 ? _a : client === null || client === void 0 ? void 0 : client.id) !== null && _b !== void 0 ? _b : client === null || client === void 0 ? void 0 : client.order_id;
                    closeAllOrdersDetailDialogs();
                    return [4 /*yield*/, handleDuplicateOrderFromDialog(client, orderId, false, dispatch, setAlertErrorMsg, t)];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAllOrdersStandardPrint = function () { return __awaiter(_this, void 0, void 0, function () {
        var client, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    client = allOrdersStandardClient;
                    if (!client) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, handlePrintFromDialog(client, setPrintInvoiceData, setOpenPrintInvoiceDialog)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAllOrdersOrderNumberClick = function (order) { return __awaiter(_this, void 0, void 0, function () {
        var status, isRefundRow, result, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    status = String((_a = order === null || order === void 0 ? void 0 : order.OrderStatus) !== null && _a !== void 0 ? _a : "").toLowerCase();
                    isRefundRow = (order === null || order === void 0 ? void 0 : order.isRefundedOrders) === true && (status === "refunded" || status === "partially_refunded");
                    if (!(order === null || order === void 0 ? void 0 : order.OrderId)) {
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                        return [2 /*return*/];
                    }
                    if (isRefundRow && resolveRefundOrderDetailRequestParams(order, stReportsDisplayPayload) == null) {
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    isLoading.next(true);
                    return [4 /*yield*/, loadMergedOrderRowDetails(order, dispatch)];
                case 2:
                    result = _b.sent();
                    isLoading.next(false);
                    if (!result) {
                        setAlertErrorMsg({
                            msg: isRefundRow ? t("noRefundOrderProduct") : t("customerInvoice_ErrorMsgTryAgain"),
                            open: true,
                            severity: "error",
                        });
                        return [2 /*return*/];
                    }
                    if (result.kind === OrderRowDetailKind.Draft) {
                        setAllOrdersStandardSourceRow(null);
                        setAllOrdersStandardClient(null);
                        setAllOrdersStandardProducts([]);
                        setAllOrdersRefundProducts([]);
                        setAllOrdersDraftSourceRow(order);
                        setAllOrdersDraftClient(result.draftOrder);
                        setAllOrdersDraftProducts(result.ProductDetails);
                        setAllOrdersDetailKind(OrderRowDetailKind.Draft);
                        return [2 /*return*/];
                    }
                    if (result.kind === OrderRowDetailKind.Refund) {
                        setAllOrdersStandardSourceRow(null);
                        setAllOrdersStandardClient(null);
                        setAllOrdersStandardProducts([]);
                        setAllOrdersDraftSourceRow(null);
                        setAllOrdersDraftClient(null);
                        setAllOrdersDraftProducts([]);
                        setAllOrdersRefundProducts(result.refund_line_items);
                        setAllOrdersDetailKind(OrderRowDetailKind.Refund);
                        return [2 /*return*/];
                    }
                    setAllOrdersDraftSourceRow(null);
                    setAllOrdersDraftClient(null);
                    setAllOrdersDraftProducts([]);
                    setAllOrdersRefundProducts([]);
                    setAllOrdersStandardSourceRow(order);
                    setAllOrdersStandardClient(result.singleOrderDetailsFromShopify);
                    setAllOrdersStandardProducts(result.ProductDetails);
                    setAllOrdersDetailKind(OrderRowDetailKind.Standard);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    isLoading.next(false);
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var isInRange = function (orderDateValue) {
        var _a, _b;
        if (!((_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) || !((_b = props === null || props === void 0 ? void 0 : props.dateRange) === null || _b === void 0 ? void 0 : _b.endDate)) {
            return true;
        }
        if (!orderDateValue) {
            return false;
        }
        var parsedDate = parseDisplayDateValue(orderDateValue);
        if (!parsedDate) {
            return false;
        }
        var start = new Date(props.dateRange.startDate);
        start.setHours(0, 0, 0, 0);
        var end = new Date(props.dateRange.endDate);
        end.setHours(23, 59, 59, 999);
        return parsedDate >= start && parsedDate <= end;
    };
    var useSTOrderDetailsDateRange = Boolean(((_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) && ((_b = props === null || props === void 0 ? void 0 : props.dateRange) === null || _b === void 0 ? void 0 : _b.endDate));
    var STOrderDetailsListTab = (_c = props === null || props === void 0 ? void 0 : props.orderListTab) !== null && _c !== void 0 ? _c : "All";
    var getCurrentDateRangeKey = useCallback(function () { var _a, _b, _c, _d, _e, _f, _g, _h; return "".concat((_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) === null || _b === void 0 ? void 0 : _b.getTime) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : "", "-").concat((_h = (_g = (_f = (_e = props === null || props === void 0 ? void 0 : props.dateRange) === null || _e === void 0 ? void 0 : _e.endDate) === null || _f === void 0 ? void 0 : _f.getTime) === null || _g === void 0 ? void 0 : _g.call(_f)) !== null && _h !== void 0 ? _h : ""); }, [(_d = props === null || props === void 0 ? void 0 : props.dateRange) === null || _d === void 0 ? void 0 : _d.startDate, (_e = props === null || props === void 0 ? void 0 : props.dateRange) === null || _e === void 0 ? void 0 : _e.endDate]);
    /** True when Redux `stReportsData` matches the current date range, search, page size, tab, and page. */
    var isFetchContextCommitted = useCallback(function () {
        var _a;
        if (!useSTOrderDetailsDateRange) {
            return false;
        }
        return (lastFetchedDateKeyRef.current === getCurrentDateRangeKey() &&
            ((_a = lastFetchedSearchRef.current) !== null && _a !== void 0 ? _a : "") === debouncedSearchQuery &&
            lastFetchedPageSizeRef.current === STOrderDetailsRowsPerPage &&
            lastFetchedListTabRef.current === STOrderDetailsListTab &&
            lastFetchedPagesRef.current[STOrderDetailsListTab] === pageByTab[STOrderDetailsListTab]);
    }, [useSTOrderDetailsDateRange, debouncedSearchQuery, STOrderDetailsRowsPerPage, getCurrentDateRangeKey, STOrderDetailsListTab, pageByTab]);
    var searchInputTrimmed = searchInputText.trim();
    var searchPending = useSTOrderDetailsDateRange && searchInputTrimmed !== debouncedSearchQuery;
    var hasDebouncedSearch = debouncedSearchQuery.trim().length > 0;
    var searchResultsCommitted = lastFetchedSearchRef.current === debouncedSearchQuery;
    var STOrderDetailsListTabKey = STOrderDetailsListTab;
    var stOrderDetailsPageIndex = pageByTab[STOrderDetailsListTabKey];
    var doesPayloadMatchViewPage = useCallback(function (payload, tab, pageIndex) {
        if (tab === void 0) { tab = STOrderDetailsListTab; }
        if (pageIndex === void 0) { pageIndex = stOrderDetailsPageIndex; }
        if (!payload) {
            return false;
        }
        return hasInMemorySTOrderDetailsSliceForView(payload, tab, pageIndex, STOrderDetailsRowsPerPage);
    }, [STOrderDetailsListTab, stOrderDetailsPageIndex, STOrderDetailsRowsPerPage]);
    var tryApplyCachedPageToRedux = useCallback(function (tab, pageIndexZeroBased, searchQuery) {
        var _a, _b;
        if (searchQuery === void 0) { searchQuery = debouncedSearchQuery; }
        if (!((_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) || !((_b = props === null || props === void 0 ? void 0 : props.dateRange) === null || _b === void 0 ? void 0 : _b.endDate)) {
            return false;
        }
        var dateFrom = formatDateForAPI(props.dateRange.startDate);
        var dateTo = formatDateForAPI(props.dateRange.endDate);
        return applyStReportsFromOrdersCache(dispatch, {
            dateFrom: dateFrom,
            dateTo: dateTo,
            pageSize: STOrderDetailsRowsPerPage,
            tab: tab,
            pageNumber: pageIndexZeroBased + 1,
            searchQuery: searchQuery,
        });
    }, [dispatch, (_f = props === null || props === void 0 ? void 0 : props.dateRange) === null || _f === void 0 ? void 0 : _f.startDate, (_g = props === null || props === void 0 ? void 0 : props.dateRange) === null || _g === void 0 ? void 0 : _g.endDate, STOrderDetailsRowsPerPage, debouncedSearchQuery]);
    var getOrdersCacheRangeKey = useCallback(function (searchQuery) {
        var _a, _b;
        if (searchQuery === void 0) { searchQuery = debouncedSearchQuery; }
        if (!((_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) || !((_b = props === null || props === void 0 ? void 0 : props.dateRange) === null || _b === void 0 ? void 0 : _b.endDate)) {
            return "";
        }
        var dateFrom = formatDateForAPI(props.dateRange.startDate);
        var dateTo = formatDateForAPI(props.dateRange.endDate);
        return buildSTReportsOrdersCacheRangeKey(dateFrom, dateTo, STOrderDetailsRowsPerPage, searchQuery);
    }, [(_h = props === null || props === void 0 ? void 0 : props.dateRange) === null || _h === void 0 ? void 0 : _h.startDate, (_j = props === null || props === void 0 ? void 0 : props.dateRange) === null || _j === void 0 ? void 0 : _j.endDate, STOrderDetailsRowsPerPage, debouncedSearchQuery]);
    /** Prefer range cache for the requested tab/page, then Redux — paginating one tab must not block others. */
    var resolveStReportsViewPayload = useCallback(function (tab, pageIndexZeroBased, searchQuery) {
        if (searchQuery === void 0) { searchQuery = debouncedSearchQuery; }
        var rangeKey = getOrdersCacheRangeKey(searchQuery);
        if (rangeKey) {
            var fromCache = getSTReportsDisplayPayloadFromCache(stReportsOrdersByDateRange, rangeKey, tab, pageIndexZeroBased + 1, STOrderDetailsRowsPerPage);
            if (fromCache) {
                return fromCache;
            }
        }
        var memory = stReportsData;
        if (hasInMemorySTOrderDetailsSliceForView(memory, tab, pageIndexZeroBased, STOrderDetailsRowsPerPage)) {
            return memory !== null && memory !== void 0 ? memory : null;
        }
        return null;
    }, [stReportsData, stReportsOrdersByDateRange, STOrderDetailsRowsPerPage, debouncedSearchQuery, getOrdersCacheRangeKey]);
    var hasAppliedDateRangeCacheAuthority = useCallback(function (searchQuery) {
        if (searchQuery === void 0) { searchQuery = debouncedSearchQuery; }
        var rangeKey = getOrdersCacheRangeKey(searchQuery);
        if (!rangeKey) {
            return false;
        }
        return hasSTReportsExactRangeCacheAuthority(stReportsOrdersByDateRange, rangeKey, STOrderDetailsRowsPerPage);
    }, [getOrdersCacheRangeKey, stReportsOrdersByDateRange, STOrderDetailsRowsPerPage]);
    var stReportsDisplayPayload = useMemo(function () {
        /** Debounce in progress — do not show previous range/search grid totals or slices. */
        if (searchPending) {
            return null;
        }
        var searchQuery = debouncedSearchQuery;
        if (hasDebouncedSearch && !searchResultsCommitted) {
            return null;
        }
        var resolved = resolveStReportsViewPayload(STOrderDetailsListTab, stOrderDetailsPageIndex, searchQuery);
        if (resolved) {
            return resolved;
        }
        /** Filtered page change: keep prior page rows visible until the next page response lands. */
        if (hasDebouncedSearch && stOrderDetailsTableLoading && stReportsSearchSnapshot) {
            return stReportsSearchSnapshot;
        }
        return null;
    }, [
        resolveStReportsViewPayload,
        stReportsData,
        stReportsOrdersByDateRange,
        stReportsSearchSnapshot,
        searchPending,
        hasDebouncedSearch,
        debouncedSearchQuery,
        searchResultsCommitted,
        STOrderDetailsListTab,
        stOrderDetailsPageIndex,
        STOrderDetailsRowsPerPage,
        stOrderDetailsTableLoading,
    ]);
    var noDataForSelectedPeriod = useMemo(function () { return isNoDataForSTOrderDetailsAppliedRange(props === null || props === void 0 ? void 0 : props.dateRange, stReportsDisplayPayload); }, [(_k = props === null || props === void 0 ? void 0 : props.dateRange) === null || _k === void 0 ? void 0 : _k.startDate, (_l = props === null || props === void 0 ? void 0 : props.dateRange) === null || _l === void 0 ? void 0 : _l.endDate, stReportsDisplayPayload]);
    var serverTabSliceMode = useMemo(function () { return getSTOrderDetailsTabSlicesFromPayload(stReportsDisplayPayload) != null; }, [stReportsDisplayPayload]);
    /** Initial date-range and search loads use `All`; tab switches read merged cache — only pagination uses the active tab. */
    var STOrderDetailsRequestActiveTab = serverTabSliceMode && !serverPaginationFetch ? "All" : STOrderDetailsListTab;
    var isRefundedListTab = useSTOrderDetailsDateRange && STOrderDetailsListTab === "Refunded";
    var readSTOrderDetailsTotalFromPayload = useCallback(function (payload) {
        var _a;
        if (!payload) {
            return null;
        }
        var fromSlice = getSTOrderDetailsTotalCountForUiTab(payload, STOrderDetailsListTab);
        if (fromSlice != null && fromSlice >= 0) {
            return fromSlice;
        }
        var raw = (_a = payload.TotalCount) !== null && _a !== void 0 ? _a : payload.totalCount;
        var n = Number(raw);
        return Number.isFinite(n) && n >= 0 ? n : null;
    }, [STOrderDetailsListTab]);
    var STOrderDetailsTotalRowCount = useMemo(function () {
        if (!useSTOrderDetailsDateRange) {
            return 0;
        }
        if (searchPending || (hasDebouncedSearch && !searchResultsCommitted)) {
            return 0;
        }
        /** Page-only transitions: keep prior total so page index and API `pageNumber` are not reset to 1. */
        if (!isFetchContextCommitted()) {
            var known = lastKnownTotalByTabRef.current[STOrderDetailsListTabKey];
            if (known != null && known > 0) {
                return known;
            }
            var fromSnapshot = readSTOrderDetailsTotalFromPayload(stReportsPaginationSnapshot);
            if (fromSnapshot != null) {
                return fromSnapshot;
            }
            var fromDisplay_1 = readSTOrderDetailsTotalFromPayload(stReportsDisplayPayload);
            if (fromDisplay_1 != null) {
                return fromDisplay_1;
            }
            return 0;
        }
        var fromDisplay = readSTOrderDetailsTotalFromPayload(stReportsDisplayPayload);
        if (fromDisplay != null) {
            return fromDisplay;
        }
        return 0;
    }, [
        stReportsDisplayPayload,
        stReportsPaginationSnapshot,
        readSTOrderDetailsTotalFromPayload,
        useSTOrderDetailsDateRange,
        STOrderDetailsListTabKey,
        hasDebouncedSearch,
        searchPending,
        searchResultsCommitted,
        isFetchContextCommitted,
    ]);
    var STOrderDetailsPage = clampSTOrderDetailsPageIndex(stOrderDetailsPageIndex, STOrderDetailsTotalRowCount, STOrderDetailsRowsPerPage);
    useEffect(function () {
        if (stReportsData == null || !isFetchContextCommitted()) {
            return;
        }
        if (debouncedSearchQuery.trim().length === 0) {
            return;
        }
        if (lastFetchedSearchRef.current !== debouncedSearchQuery) {
            return;
        }
        if (isSTOrderDetailsSliceCachedForPage(stReportsData, STOrderDetailsListTab, STOrderDetailsPage, STOrderDetailsRowsPerPage)) {
            setStReportsSearchSnapshot(stReportsData);
        }
    }, [stReportsData, debouncedSearchQuery, STOrderDetailsListTab, STOrderDetailsPage, STOrderDetailsRowsPerPage, isFetchContextCommitted]);
    var isDefaultBootstrapUiState = useMemo(function () {
        if (!useSTOrderDetailsDateRange) {
            return false;
        }
        return (isSTOrderDetailsDefaultDateRange(props === null || props === void 0 ? void 0 : props.dateRange) &&
            STOrderDetailsListTab === "All" &&
            STOrderDetailsPage === 0 &&
            STOrderDetailsRowsPerPage === ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE &&
            !(debouncedSearchQuery === null || debouncedSearchQuery === void 0 ? void 0 : debouncedSearchQuery.trim()));
    }, [
        useSTOrderDetailsDateRange,
        (_m = props === null || props === void 0 ? void 0 : props.dateRange) === null || _m === void 0 ? void 0 : _m.startDate,
        (_o = props === null || props === void 0 ? void 0 : props.dateRange) === null || _o === void 0 ? void 0 : _o.endDate,
        STOrderDetailsListTab,
        STOrderDetailsPage,
        STOrderDetailsRowsPerPage,
        debouncedSearchQuery,
    ]);
    /**
     * Stable request key — excludes list tab so tab switches do not retrigger the fetch effect.
     * Server calls: date/search/page-size change (`All` tab) or `serverPaginationFetch` (one tab page).
     */
    var stOrderDetailsFetchSignature = useMemo(function () {
        var _a, _b;
        if (!((_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) || !((_b = props === null || props === void 0 ? void 0 : props.dateRange) === null || _b === void 0 ? void 0 : _b.endDate)) {
            return "";
        }
        var dateFrom = formatDateForAPI(props.dateRange.startDate);
        var dateTo = formatDateForAPI(props.dateRange.endDate);
        var base = {
            dateFrom: dateFrom,
            dateTo: dateTo,
            pageSize: STOrderDetailsRowsPerPage,
        };
        if (hasDebouncedSearch) {
            return JSON.stringify(__assign(__assign({}, base), { mode: "search", search: debouncedSearchQuery, pagination: serverPaginationFetch, revision: rangeFetchRevision }));
        }
        return JSON.stringify(__assign(__assign({}, base), { mode: "range", pagination: serverPaginationFetch, revision: rangeFetchRevision }));
    }, [(_p = props === null || props === void 0 ? void 0 : props.dateRange) === null || _p === void 0 ? void 0 : _p.startDate, (_q = props === null || props === void 0 ? void 0 : props.dateRange) === null || _q === void 0 ? void 0 : _q.endDate, hasDebouncedSearch, STOrderDetailsRowsPerPage, debouncedSearchQuery, serverPaginationFetch, rangeFetchRevision]);
    var buildSTOrderDetailsFetchRequest = useCallback(function () {
        var dateFrom = formatDateForAPI(props.dateRange.startDate);
        var dateTo = formatDateForAPI(props.dateRange.endDate);
        var base = __assign({ dateFrom: dateFrom, dateTo: dateTo, dateField: "", pageSize: STOrderDetailsRowsPerPage }, buildSTOrderDetailsSearchQueryParam(debouncedSearchQuery));
        if (serverPaginationFetch) {
            return __assign(__assign({}, base), { activeTab: serverPaginationFetch.tab, pageNumber: serverPaginationFetch.page + 1 });
        }
        if (debouncedSearchQuery.trim().length > 0) {
            return __assign(__assign({}, base), { activeTab: STOrderDetailsListTab, pageNumber: stOrderDetailsPageIndex + 1 });
        }
        return __assign(__assign({}, base), { activeTab: "All", pageNumber: 1 });
    }, [
        (_r = props === null || props === void 0 ? void 0 : props.dateRange) === null || _r === void 0 ? void 0 : _r.startDate,
        (_s = props === null || props === void 0 ? void 0 : props.dateRange) === null || _s === void 0 ? void 0 : _s.endDate,
        STOrderDetailsRowsPerPage,
        debouncedSearchQuery,
        STOrderDetailsListTab,
        stOrderDetailsPageIndex,
        serverPaginationFetch,
    ]);
    var tryApplyStReportsFromReduxCache = useCallback(function () {
        var _a, _b;
        if (!((_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) || !((_b = props === null || props === void 0 ? void 0 : props.dateRange) === null || _b === void 0 ? void 0 : _b.endDate)) {
            return false;
        }
        var dateFrom = formatDateForAPI(props.dateRange.startDate);
        var dateTo = formatDateForAPI(props.dateRange.endDate);
        return applyStReportsFromOrdersCache(dispatch, {
            dateFrom: dateFrom,
            dateTo: dateTo,
            pageSize: STOrderDetailsRowsPerPage,
            tab: STOrderDetailsListTab,
            pageNumber: stOrderDetailsPageIndex + 1,
            searchQuery: debouncedSearchQuery,
        });
    }, [dispatch, (_t = props === null || props === void 0 ? void 0 : props.dateRange) === null || _t === void 0 ? void 0 : _t.startDate, (_u = props === null || props === void 0 ? void 0 : props.dateRange) === null || _u === void 0 ? void 0 : _u.endDate, STOrderDetailsRowsPerPage, STOrderDetailsListTab, stOrderDetailsPageIndex, debouncedSearchQuery]);
    var hasInMemorySearchResponseForCurrentQuery = useCallback(function () {
        if (!hasDebouncedSearch || lastFetchedSearchRef.current !== debouncedSearchQuery) {
            return false;
        }
        var memoryPayload = stReportsData;
        return isSTOrderDetailsSliceCachedForPage(memoryPayload, STOrderDetailsListTab, stOrderDetailsPageIndex, STOrderDetailsRowsPerPage);
    }, [hasDebouncedSearch, debouncedSearchQuery, stReportsData, STOrderDetailsListTab, stOrderDetailsPageIndex, STOrderDetailsRowsPerPage]);
    var markStOrderDetailsFetchSignatureSatisfied = useCallback(function (pagesOverride) {
        lastFetchSignatureRef.current = stOrderDetailsFetchSignature;
        lastFetchedSearchRef.current = debouncedSearchQuery;
        lastFetchedHadSearchRef.current = debouncedSearchQuery.trim().length > 0;
        lastFetchedPagesRef.current = pagesOverride ? __assign({}, pagesOverride) : __assign({}, pageByTab);
        lastFetchedPageSizeRef.current = STOrderDetailsRowsPerPage;
        lastFetchedDateKeyRef.current = getCurrentDateRangeKey();
        lastFetchedListTabRef.current = STOrderDetailsListTab;
        setStOrderDetailsTableLoading(false);
    }, [stOrderDetailsFetchSignature, debouncedSearchQuery, pageByTab, STOrderDetailsRowsPerPage, getCurrentDateRangeKey, STOrderDetailsListTab]);
    var restoreDateRangeDataFromCache = useCallback(function () {
        var _a, _b;
        if (!((_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) || !((_b = props === null || props === void 0 ? void 0 : props.dateRange) === null || _b === void 0 ? void 0 : _b.endDate)) {
            return false;
        }
        var dateFrom = formatDateForAPI(props.dateRange.startDate);
        var dateTo = formatDateForAPI(props.dateRange.endDate);
        var restored = applyStReportsFromOrdersCache(dispatch, {
            dateFrom: dateFrom,
            dateTo: dateTo,
            pageSize: STOrderDetailsRowsPerPage,
            tab: STOrderDetailsListTab,
            pageNumber: pageByTab[STOrderDetailsListTabKey] + 1,
            searchQuery: "",
        });
        if (restored) {
            lastFetchedHadSearchRef.current = false;
            lastFetchedSearchRef.current = "";
            lastFetchedDateKeyRef.current = getCurrentDateRangeKey();
        }
        return restored;
    }, [
        dispatch,
        (_v = props === null || props === void 0 ? void 0 : props.dateRange) === null || _v === void 0 ? void 0 : _v.startDate,
        (_w = props === null || props === void 0 ? void 0 : props.dateRange) === null || _w === void 0 ? void 0 : _w.endDate,
        STOrderDetailsRowsPerPage,
        STOrderDetailsListTab,
        STOrderDetailsListTabKey,
        pageByTab,
        getCurrentDateRangeKey,
    ]);
    var tryServeStOrderDetailsFromMemoryOrCache = useCallback(function () {
        var _a, _b;
        if (hasDebouncedSearch) {
            if (tryApplyStReportsFromReduxCache()) {
                return doesPayloadMatchViewPage((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsData);
            }
            return hasInMemorySearchResponseForCurrentQuery();
        }
        if (lastFetchedHadSearchRef.current) {
            return false;
        }
        var currentDateKey = getCurrentDateRangeKey();
        /** Redux grid rows are only valid for the date range that produced them — not after picker change. */
        if (currentDateKey === lastFetchedDateKeyRef.current) {
            var reduxPayload = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.stReportsData;
            if (doesPayloadMatchViewPage(reduxPayload)) {
                return true;
            }
        }
        if (resolveStReportsViewPayload(STOrderDetailsListTab, stOrderDetailsPageIndex, "") != null) {
            return tryApplyCachedPageToRedux(STOrderDetailsListTab, stOrderDetailsPageIndex, "");
        }
        return false;
    }, [
        getCurrentDateRangeKey,
        hasDebouncedSearch,
        STOrderDetailsListTab,
        stOrderDetailsPageIndex,
        tryApplyStReportsFromReduxCache,
        hasInMemorySearchResponseForCurrentQuery,
        doesPayloadMatchViewPage,
        tryApplyCachedPageToRedux,
        resolveStReportsViewPayload,
        debouncedSearchQuery,
    ]);
    /** Remount / return from order detail: sync in-memory refs when Redux or range cache already holds this tab/page. */
    var rehydrateStOrderDetailsFromMemoryOrCache = useCallback(function () {
        if (!useSTOrderDetailsDateRange) {
            return false;
        }
        if (tryServeStOrderDetailsFromMemoryOrCache()) {
            markStOrderDetailsFetchSignatureSatisfied();
            return true;
        }
        return false;
    }, [useSTOrderDetailsDateRange, tryServeStOrderDetailsFromMemoryOrCache, markStOrderDetailsFetchSignatureSatisfied]);
    var didRehydrateOnMountRef = useRef(false);
    useEffect(function () {
        if (!useSTOrderDetailsDateRange || didRehydrateOnMountRef.current) {
            return;
        }
        didRehydrateOnMountRef.current = true;
        rehydrateStOrderDetailsFromMemoryOrCache();
    }, [useSTOrderDetailsDateRange, rehydrateStOrderDetailsFromMemoryOrCache]);
    var handleSearchInputChange = useCallback(function (text) {
        var _a;
        setSearchInputText(text);
        salesOrderSearchText.next({
            searchText: text,
            orderTab: STOrderDetailsListTab,
        });
        if (!useSTOrderDetailsDateRange) {
            return;
        }
        var trimmed = text.trim();
        /** Clear search immediately (no 4s wait) so cached date-range data can restore. */
        if (!trimmed) {
            lastFetchedHadSearchRef.current = true;
            lastFetchSignatureRef.current = null;
            fetchInFlightSignatureRef.current = null;
            setStOrderDetailsTableLoading(true);
            setDebouncedSearchQuery("");
            return;
        }
        /** New query while debouncing — hide stale pagination/totals until the fetch completes. */
        if (trimmed !== debouncedSearchQuery && trimmed !== ((_a = lastFetchedSearchRef.current) !== null && _a !== void 0 ? _a : "")) {
            lastFetchSignatureRef.current = null;
            fetchInFlightSignatureRef.current = null;
            setStOrderDetailsTableLoading(true);
        }
    }, [STOrderDetailsListTab, useSTOrderDetailsDateRange, debouncedSearchQuery]);
    var isSearchQueryAlreadyApplied = useCallback(function (query) {
        var _a;
        var trimmed = query.trim();
        return trimmed === debouncedSearchQuery.trim() && trimmed === ((_a = lastFetchedSearchRef.current) !== null && _a !== void 0 ? _a : "").trim();
    }, [debouncedSearchQuery]);
    var handleSearchSubmit = useCallback(function () {
        if (!useSTOrderDetailsDateRange) {
            return;
        }
        var trimmed = searchInputText.trim();
        if (isSearchQueryAlreadyApplied(trimmed)) {
            return;
        }
        lastFetchSignatureRef.current = null;
        fetchInFlightSignatureRef.current = null;
        setStOrderDetailsTableLoading(true);
        setDebouncedSearchQuery(trimmed);
    }, [useSTOrderDetailsDateRange, searchInputText, isSearchQueryAlreadyApplied]);
    useEffect(function () {
        if (!useSTOrderDetailsDateRange) {
            return;
        }
        var timer = window.setTimeout(function () {
            var next = searchInputText.trim();
            if (next === debouncedSearchQuery.trim()) {
                return;
            }
            setDebouncedSearchQuery(next);
        }, ST_ORDER_DETAILS_SEARCH_DEBOUNCE_MS);
        return function () { return window.clearTimeout(timer); };
    }, [searchInputText, debouncedSearchQuery, useSTOrderDetailsDateRange]);
    var prevDebouncedSearchRef = useRef(null);
    useEffect(function () {
        var _a, _b;
        if (!useSTOrderDetailsDateRange) {
            return;
        }
        if (prevDebouncedSearchRef.current !== null && prevDebouncedSearchRef.current !== debouncedSearchQuery) {
            var clearedSearch = debouncedSearchQuery.trim().length === 0 && ((_b = (_a = prevDebouncedSearchRef.current) === null || _a === void 0 ? void 0 : _a.trim().length) !== null && _b !== void 0 ? _b : 0) > 0;
            setPageByTab(createSTOrderDetailsInitialTabPages());
            setServerPaginationFetch(null);
            setStReportsPaginationSnapshot(null);
            setStReportsSearchSnapshot(null);
            lastFetchSignatureRef.current = null;
            fetchInFlightSignatureRef.current = null;
            lastKnownTotalByTabRef.current = {};
            setStOrderDetailsTableLoading(true);
            if (clearedSearch) {
                lastFetchedHadSearchRef.current = true;
                if (restoreDateRangeDataFromCache()) {
                    setStOrderDetailsTableLoading(false);
                }
            }
            else if (debouncedSearchQuery.trim().length > 0) {
                lastFetchedHadSearchRef.current = false;
            }
        }
        prevDebouncedSearchRef.current = debouncedSearchQuery;
    }, [debouncedSearchQuery, useSTOrderDetailsDateRange, restoreDateRangeDataFromCache]);
    var prevListTabRef = useRef(STOrderDetailsListTab);
    useLayoutEffect(function () {
        var _a;
        if (!useSTOrderDetailsDateRange || prevListTabRef.current === STOrderDetailsListTab) {
            return;
        }
        prevListTabRef.current = STOrderDetailsListTab;
        setServerPaginationFetch(null);
        /** Every tab click shows page 1 (first 50 rows) — still served from cache when available. */
        var nextPages = __assign(__assign({}, pageByTab), (_a = {}, _a[STOrderDetailsListTabKey] = 0, _a));
        setPageByTab(nextPages);
        var searchQuery = hasDebouncedSearch ? debouncedSearchQuery : "";
        var resolved = resolveStReportsViewPayload(STOrderDetailsListTab, 0, searchQuery);
        var tabCacheHit = resolved != null || tryApplyCachedPageToRedux(STOrderDetailsListTab, 0, searchQuery);
        if (tabCacheHit) {
            if (resolved != null) {
                tryApplyCachedPageToRedux(STOrderDetailsListTab, 0, searchQuery);
            }
            lastFetchedListTabRef.current = STOrderDetailsListTab;
            markStOrderDetailsFetchSignatureSatisfied(nextPages);
            return;
        }
        if (!hasAppliedDateRangeCacheAuthority(searchQuery)) {
            lastFetchSignatureRef.current = null;
            lastFetchedDateKeyRef.current = "";
            setRangeFetchRevision(function (revision) { return revision + 1; });
            setStOrderDetailsTableLoading(true);
            return;
        }
        /** Range already loaded — tab switches never call the server. */
        lastFetchedListTabRef.current = STOrderDetailsListTab;
        markStOrderDetailsFetchSignatureSatisfied(nextPages);
    }, [
        STOrderDetailsListTab,
        STOrderDetailsListTabKey,
        useSTOrderDetailsDateRange,
        hasDebouncedSearch,
        debouncedSearchQuery,
        resolveStReportsViewPayload,
        hasAppliedDateRangeCacheAuthority,
        tryApplyCachedPageToRedux,
        doesPayloadMatchViewPage,
        markStOrderDetailsFetchSignatureSatisfied,
    ]);
    useEffect(function () {
        if (!useSTOrderDetailsDateRange || stOrderDetailsTableLoading || searchPending || stReportsDisplayPayload == null) {
            return;
        }
        if (STOrderDetailsTotalRowCount <= 0) {
            return;
        }
        setPageByTab(function (prev) {
            var _a;
            var clamped = clampSTOrderDetailsPageIndex(prev[STOrderDetailsListTabKey], STOrderDetailsTotalRowCount, STOrderDetailsRowsPerPage);
            if (clamped === prev[STOrderDetailsListTabKey]) {
                return prev;
            }
            return __assign(__assign({}, prev), (_a = {}, _a[STOrderDetailsListTabKey] = clamped, _a));
        });
    }, [
        STOrderDetailsTotalRowCount,
        STOrderDetailsRowsPerPage,
        STOrderDetailsListTabKey,
        useSTOrderDetailsDateRange,
        stOrderDetailsTableLoading,
        searchPending,
        stReportsDisplayPayload,
    ]);
    useEffect(function () {
        if (!useSTOrderDetailsDateRange || !isFetchContextCommitted()) {
            return;
        }
        lastKnownTotalByTabRef.current[STOrderDetailsListTabKey] = STOrderDetailsTotalRowCount;
    }, [STOrderDetailsTotalRowCount, STOrderDetailsListTabKey, useSTOrderDetailsDateRange, isFetchContextCommitted]);
    var prevDateRangeKeyRef = useRef(null);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var key = "".concat((_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) === null || _b === void 0 ? void 0 : _b.getTime) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : "", "-").concat((_h = (_g = (_f = (_e = props === null || props === void 0 ? void 0 : props.dateRange) === null || _e === void 0 ? void 0 : _e.endDate) === null || _f === void 0 ? void 0 : _f.getTime) === null || _g === void 0 ? void 0 : _g.call(_f)) !== null && _h !== void 0 ? _h : "");
        var hasAppliedRange = Boolean(((_j = props === null || props === void 0 ? void 0 : props.dateRange) === null || _j === void 0 ? void 0 : _j.startDate) && ((_k = props === null || props === void 0 ? void 0 : props.dateRange) === null || _k === void 0 ? void 0 : _k.endDate));
        if (hasAppliedRange && prevDateRangeKeyRef.current !== null && prevDateRangeKeyRef.current !== key) {
            setPageByTab(createSTOrderDetailsInitialTabPages());
            setSearchInputText("");
            setDebouncedSearchQuery("");
            lastFetchedSearchRef.current = null;
            lastFetchedHadSearchRef.current = false;
            salesOrderSearchText.next({
                searchText: "",
                orderTab: STOrderDetailsListTab,
            });
            setStReportsPaginationSnapshot(null);
            setStReportsSearchSnapshot(null);
            setServerPaginationFetch(null);
            lastFetchSignatureRef.current = null;
            fetchInFlightSignatureRef.current = null;
            lastFetchedPagesRef.current = createSTOrderDetailsInitialTabPages();
            lastFetchedDateKeyRef.current = "";
            lastFetchedListTabRef.current = "";
            lastFetchedPageSizeRef.current = STOrderDetailsRowsPerPage;
            lastKnownTotalByTabRef.current = {};
            setStOrderDetailsTableLoading(true);
            dispatch({
                payload: null,
                type: SalesRepDataActionType.ST_REPORTS_DATA,
            });
        }
        if (hasAppliedRange) {
            prevDateRangeKeyRef.current = key;
        }
    }, [(_x = props === null || props === void 0 ? void 0 : props.dateRange) === null || _x === void 0 ? void 0 : _x.startDate, (_y = props === null || props === void 0 ? void 0 : props.dateRange) === null || _y === void 0 ? void 0 : _y.endDate, dispatch, STOrderDetailsListTab, STOrderDetailsRowsPerPage]);
    var prevResetSessionKeyRef = useRef(0);
    useEffect(function () {
        var _a;
        var key = (_a = props === null || props === void 0 ? void 0 : props.resetSessionKey) !== null && _a !== void 0 ? _a : 0;
        if (key > 0 && key !== prevResetSessionKeyRef.current) {
            prevResetSessionKeyRef.current = key;
            setPageByTab(createSTOrderDetailsInitialTabPages());
            setSearchInputText("");
            setDebouncedSearchQuery("");
            setServerPaginationFetch(null);
            lastFetchedSearchRef.current = null;
            lastFetchSignatureRef.current = null;
            fetchInFlightSignatureRef.current = null;
            lastFetchedPagesRef.current = createSTOrderDetailsInitialTabPages();
            lastFetchedDateKeyRef.current = "";
            lastKnownTotalByTabRef.current = {};
            setStReportsPaginationSnapshot(null);
            setStReportsSearchSnapshot(null);
            setStOrderDetailsTableLoading(false);
        }
    }, [props === null || props === void 0 ? void 0 : props.resetSessionKey]);
    useEffect(function () {
        var _a, _b, _c;
        if (useSTOrderDetailsDateRange) {
            return;
        }
        if ((ordersData === null || ordersData === void 0 ? void 0 : ordersData.isPaidUnPaidOrdersLoaded) === undefined || (ordersData === null || ordersData === void 0 ? void 0 : ordersData.isDraftOrdersLoaded) === undefined) {
            isLoading.next(true);
        }
        if ((ordersData === null || ordersData === void 0 ? void 0 : ordersData.isPaidUnPaidOrdersLoaded) && (ordersData === null || ordersData === void 0 ? void 0 : ordersData.isDraftOrdersLoaded)) {
            var mergedRows = __spreadArray(__spreadArray(__spreadArray([], ((_a = ordersData === null || ordersData === void 0 ? void 0 : ordersData.AllOrdersCommission) !== null && _a !== void 0 ? _a : []), true), ((_b = ordersData === null || ordersData === void 0 ? void 0 : ordersData.draftOrdersDetails) !== null && _b !== void 0 ? _b : []), true), ((_c = ordersData === null || ordersData === void 0 ? void 0 : ordersData.refundOrdersDetails) !== null && _c !== void 0 ? _c : []), true);
            var dateFilteredRows = mergedRows.filter(function (row) { return isInRange(row === null || row === void 0 ? void 0 : row.orderDate); });
            setOrders(dateFilteredRows);
            setFiltered(dateFilteredRows);
            isLoading.next(false);
            setOrdersLoading(false);
        }
    }, [ordersData, (_z = props === null || props === void 0 ? void 0 : props.dateRange) === null || _z === void 0 ? void 0 : _z.startDate, (_0 = props === null || props === void 0 ? void 0 : props.dateRange) === null || _0 === void 0 ? void 0 : _0.endDate, useSTOrderDetailsDateRange]);
    /** Latest helpers for the fetch effect — avoids re-running when Redux `stReportsData` clears mid-request. */
    var fetchEffectHelpersRef = useRef({
        dispatch: dispatch,
        buildSTOrderDetailsFetchRequest: buildSTOrderDetailsFetchRequest,
        tryServeStOrderDetailsFromMemoryOrCache: tryServeStOrderDetailsFromMemoryOrCache,
        markStOrderDetailsFetchSignatureSatisfied: markStOrderDetailsFetchSignatureSatisfied,
        tryApplyStReportsFromReduxCache: tryApplyStReportsFromReduxCache,
        restoreDateRangeDataFromCache: restoreDateRangeDataFromCache,
        debouncedSearchQuery: debouncedSearchQuery,
        hasDebouncedSearch: hasDebouncedSearch,
        pageByTab: pageByTab,
        STOrderDetailsRowsPerPage: STOrderDetailsRowsPerPage,
        STOrderDetailsListTab: STOrderDetailsListTab,
        dateRangeStart: (_1 = props === null || props === void 0 ? void 0 : props.dateRange) === null || _1 === void 0 ? void 0 : _1.startDate,
        dateRangeEnd: (_2 = props === null || props === void 0 ? void 0 : props.dateRange) === null || _2 === void 0 ? void 0 : _2.endDate,
        getCurrentDateRangeKey: getCurrentDateRangeKey,
    });
    fetchEffectHelpersRef.current = {
        dispatch: dispatch,
        buildSTOrderDetailsFetchRequest: buildSTOrderDetailsFetchRequest,
        tryServeStOrderDetailsFromMemoryOrCache: tryServeStOrderDetailsFromMemoryOrCache,
        markStOrderDetailsFetchSignatureSatisfied: markStOrderDetailsFetchSignatureSatisfied,
        tryApplyStReportsFromReduxCache: tryApplyStReportsFromReduxCache,
        restoreDateRangeDataFromCache: restoreDateRangeDataFromCache,
        debouncedSearchQuery: debouncedSearchQuery,
        hasDebouncedSearch: hasDebouncedSearch,
        pageByTab: pageByTab,
        STOrderDetailsRowsPerPage: STOrderDetailsRowsPerPage,
        STOrderDetailsListTab: STOrderDetailsListTab,
        dateRangeStart: (_3 = props === null || props === void 0 ? void 0 : props.dateRange) === null || _3 === void 0 ? void 0 : _3.startDate,
        dateRangeEnd: (_4 = props === null || props === void 0 ? void 0 : props.dateRange) === null || _4 === void 0 ? void 0 : _4.endDate,
        getCurrentDateRangeKey: getCurrentDateRangeKey,
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!useSTOrderDetailsDateRange) {
            return;
        }
        /** Wait for debounce — no API until `debouncedSearchQuery` catches up to input. */
        if (searchPending) {
            setStOrderDetailsTableLoading(true);
            return;
        }
        var helpers = fetchEffectHelpersRef.current;
        var currentDateKey = "".concat((_c = (_b = (_a = helpers.dateRangeStart) === null || _a === void 0 ? void 0 : _a.getTime) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : "", "-").concat((_f = (_e = (_d = helpers.dateRangeEnd) === null || _d === void 0 ? void 0 : _d.getTime) === null || _e === void 0 ? void 0 : _e.call(_d)) !== null && _f !== void 0 ? _f : "");
        if (isDefaultBootstrapUiState && !helpers.hasDebouncedSearch && lastFetchedDateKeyRef.current === currentDateKey) {
            if (((_g = store.getState().salesRepData) === null || _g === void 0 ? void 0 : _g.stReportsData) == null) {
                if (!helpers.tryApplyStReportsFromReduxCache()) {
                    helpers.dispatch(restoreStReportsFromDefault());
                }
            }
            if (helpers.tryServeStOrderDetailsFromMemoryOrCache()) {
                helpers.markStOrderDetailsFetchSignatureSatisfied();
                return;
            }
        }
        if (!stOrderDetailsFetchSignature) {
            return;
        }
        if (fetchInFlightSignatureRef.current === stOrderDetailsFetchSignature) {
            return;
        }
        if (lastFetchSignatureRef.current === stOrderDetailsFetchSignature) {
            if (helpers.tryServeStOrderDetailsFromMemoryOrCache()) {
                setStOrderDetailsTableLoading(false);
                return;
            }
            lastFetchSignatureRef.current = null;
        }
        var dateKey = "".concat((_k = (_j = (_h = helpers.dateRangeStart) === null || _h === void 0 ? void 0 : _h.getTime) === null || _j === void 0 ? void 0 : _j.call(_h)) !== null && _k !== void 0 ? _k : "", "-").concat((_o = (_m = (_l = helpers.dateRangeEnd) === null || _l === void 0 ? void 0 : _l.getTime) === null || _m === void 0 ? void 0 : _m.call(_l)) !== null && _o !== void 0 ? _o : "");
        var searchChangedSinceLastFetch = lastFetchedSearchRef.current !== helpers.debouncedSearchQuery;
        var isBulkRangeReload = searchChangedSinceLastFetch ||
            dateKey !== lastFetchedDateKeyRef.current ||
            helpers.STOrderDetailsRowsPerPage !== lastFetchedPageSizeRef.current;
        var isPaginationServerFetch = serverPaginationFetch != null;
        var isPaginationOnlyReload = isPaginationServerFetch && !isBulkRangeReload;
        if (helpers.tryServeStOrderDetailsFromMemoryOrCache()) {
            helpers.markStOrderDetailsFetchSignatureSatisfied();
            if (isPaginationServerFetch) {
                setServerPaginationFetch(null);
            }
            return;
        }
        if (isBulkRangeReload &&
            tryApplyCachedPageToRedux(STOrderDetailsListTab, pageByTab[STOrderDetailsListTabKey], helpers.hasDebouncedSearch ? helpers.debouncedSearchQuery : "")) {
            helpers.markStOrderDetailsFetchSignatureSatisfied();
            return;
        }
        if (!isBulkRangeReload && !isPaginationServerFetch) {
            setStOrderDetailsTableLoading(false);
            return;
        }
        setStOrderDetailsTableLoading(true);
        if (isBulkRangeReload) {
            setStReportsPaginationSnapshot(null);
            setStReportsSearchSnapshot(null);
            lastKnownTotalByTabRef.current = {};
            dispatch({
                payload: null,
                type: SalesRepDataActionType.ST_REPORTS_DATA,
            });
        }
        var fetchRequest = helpers.buildSTOrderDetailsFetchRequest();
        if (searchChangedSinceLastFetch || isBulkRangeReload) {
            setPageByTab(createSTOrderDetailsInitialTabPages());
        }
        /** Keep prior rows visible only for pagination within the same date/search/page-size context. */
        fetchRequest.preservePreviousPayload = isPaginationOnlyReload;
        var signatureForThisRun = stOrderDetailsFetchSignature;
        fetchInFlightSignatureRef.current = signatureForThisRun;
        var cancelled = false;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, helpers.dispatch(getSalesRepSTReports(fetchRequest))];
                    case 1:
                        _b.sent();
                        if (!cancelled) {
                            lastFetchSignatureRef.current = signatureForThisRun;
                            lastFetchedSearchRef.current = helpers.debouncedSearchQuery;
                            lastFetchedHadSearchRef.current = helpers.hasDebouncedSearch;
                            lastFetchedPagesRef.current = __assign(__assign({}, pageByTab), (serverPaginationFetch ? (_a = {}, _a[serverPaginationFetch.tab] = serverPaginationFetch.page, _a) : {}));
                            lastFetchedPageSizeRef.current = helpers.STOrderDetailsRowsPerPage;
                            lastFetchedDateKeyRef.current = dateKey;
                            lastFetchedListTabRef.current = STOrderDetailsListTab;
                            setServerPaginationFetch(null);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _b.sent();
                        logClientRuntimeError("OrdersTableBL.fetchSTReports", error_3);
                        if (!cancelled) {
                            setOrders([]);
                            setFiltered([]);
                            lastFetchSignatureRef.current = null;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        if (fetchInFlightSignatureRef.current === signatureForThisRun) {
                            fetchInFlightSignatureRef.current = null;
                        }
                        if (!cancelled) {
                            setStOrderDetailsTableLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            /** Do not cancel when Redux clears `stReportsData` for the same in-flight signature. */
            if (fetchInFlightSignatureRef.current === signatureForThisRun) {
                return;
            }
            cancelled = true;
        };
    }, [useSTOrderDetailsDateRange, stOrderDetailsFetchSignature, searchPending, isDefaultBootstrapUiState, stReportsDefaultData, serverPaginationFetch, rangeFetchRevision]);
    var ordersForDisplay = useMemo(function () {
        if (!useSTOrderDetailsDateRange) {
            return orders;
        }
        if (searchPending) {
            return [];
        }
        if (stOrderDetailsTableLoading && stReportsDisplayPayload == null) {
            return [];
        }
        try {
            if (isRefundedListTab) {
                return getSTOrderDetailsRefundRowsForUiTab(stReportsDisplayPayload, STOrderDetailsListTab);
            }
            var raw = getSTOrderDetailsOrdersForUiTab(stReportsDisplayPayload, STOrderDetailsListTab);
            return raw.map(function (r) { return mapStReportApiRowToLegacyCommission(r); });
        }
        catch (error) {
            logClientRuntimeError("OrdersTableBL.ordersForDisplay", error);
            return [];
        }
    }, [useSTOrderDetailsDateRange, isRefundedListTab, orders, stReportsDisplayPayload, STOrderDetailsListTab, stOrderDetailsTableLoading, searchPending]);
    var fetchContextCommitted = isFetchContextCommitted();
    var gridDataReadyForView = stReportsDisplayPayload != null;
    /** Spinner only when the grid has nothing valid to show for the current tab/page. */
    var isStOrderDetailsGridPending = useSTOrderDetailsDateRange &&
        !gridDataReadyForView &&
        (searchPending || (hasDebouncedSearch && !searchResultsCommitted) || stOrderDetailsTableLoading || !fetchContextCommitted);
    var showStOrderDetailsTableEmpty = !isStOrderDetailsGridPending &&
        stReportsDisplayPayload != null &&
        (!hasDebouncedSearch || searchResultsCommitted) &&
        isSTOrderDetailsActiveTabEmpty(stReportsDisplayPayload, STOrderDetailsListTab);
    var handleSTOrderDetailsPageChange = function (_event, newPage) {
        var _a;
        if (!useSTOrderDetailsDateRange) {
            return;
        }
        var clamped = clampSTOrderDetailsPageIndex(newPage, STOrderDetailsTotalRowCount, STOrderDetailsRowsPerPage);
        if (clamped === pageByTab[STOrderDetailsListTabKey]) {
            return;
        }
        var searchQuery = hasDebouncedSearch ? debouncedSearchQuery : "";
        var resolved = resolveStReportsViewPayload(STOrderDetailsListTab, clamped, searchQuery);
        var cacheHit = resolved != null || tryApplyCachedPageToRedux(STOrderDetailsListTab, clamped, searchQuery);
        if (cacheHit) {
            if (resolved != null) {
                tryApplyCachedPageToRedux(STOrderDetailsListTab, clamped, searchQuery);
            }
            var nextPages = __assign(__assign({}, pageByTab), (_a = {}, _a[STOrderDetailsListTabKey] = clamped, _a));
            setServerPaginationFetch(null);
            setStReportsPaginationSnapshot(null);
            setPageByTab(nextPages);
            markStOrderDetailsFetchSignatureSatisfied(nextPages);
            return;
        }
        setStReportsPaginationSnapshot(null);
        setStOrderDetailsTableLoading(true);
        setServerPaginationFetch({ tab: STOrderDetailsListTabKey, page: clamped });
        setPageByTab(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[STOrderDetailsListTabKey] = clamped, _a)));
        });
    };
    var handleSTOrderDetailsRowsPerPageChange = function (event) {
        var nextSize = parseInt(event.target.value, 10);
        if (!useSTOrderDetailsDateRange) {
            setSTOrderDetailsRowsPerPage(nextSize);
            setPageByTab(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[STOrderDetailsListTabKey] = 0, _a)));
            });
            return;
        }
        if (nextSize === STOrderDetailsRowsPerPage) {
            return;
        }
        setStOrderDetailsTableLoading(true);
        setServerPaginationFetch(null);
        setSTOrderDetailsRowsPerPage(nextSize);
        setPageByTab(createSTOrderDetailsInitialTabPages());
    };
    /** Paid-order totals from `StReportsOrdersResponse.TotalSubtotal` / `TotalCommission`. */
    var _45 = useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        var displayCurrency = String((_c = (_b = (_a = stReportsDisplayPayload === null || stReportsDisplayPayload === void 0 ? void 0 : stReportsDisplayPayload.Currency) !== null && _a !== void 0 ? _a : stReportsDisplayPayload === null || stReportsDisplayPayload === void 0 ? void 0 : stReportsDisplayPayload.currency) !== null && _b !== void 0 ? _b : shopCurrency) !== null && _c !== void 0 ? _c : "").trim() || shopCurrency;
        if (!useSTOrderDetailsDateRange) {
            return { paidOrdersTotalSubtotal: 0, paidOrdersTotalCommission: 0, orderDetailsDisplayCurrency: displayCurrency };
        }
        if (stOrderDetailsTableLoading || searchPending) {
            return { paidOrdersTotalSubtotal: 0, paidOrdersTotalCommission: 0, orderDetailsDisplayCurrency: displayCurrency };
        }
        var serverSubtotal = readSTOrderDetailsServerTotal(stReportsDisplayPayload === null || stReportsDisplayPayload === void 0 ? void 0 : stReportsDisplayPayload.TotalSubtotal, stReportsDisplayPayload === null || stReportsDisplayPayload === void 0 ? void 0 : stReportsDisplayPayload.totalSubtotal);
        var serverCommission = readSTOrderDetailsServerTotal(stReportsDisplayPayload === null || stReportsDisplayPayload === void 0 ? void 0 : stReportsDisplayPayload.TotalCommission, stReportsDisplayPayload === null || stReportsDisplayPayload === void 0 ? void 0 : stReportsDisplayPayload.totalCommission);
        if (serverSubtotal !== null && serverCommission !== null) {
            return {
                paidOrdersTotalSubtotal: serverSubtotal,
                paidOrdersTotalCommission: serverCommission,
                orderDetailsDisplayCurrency: displayCurrency,
            };
        }
        var sub = 0;
        var com = 0;
        for (var _i = 0, orders_1 = orders; _i < orders_1.length; _i++) {
            var order = orders_1[_i];
            var status_1 = String((_d = order === null || order === void 0 ? void 0 : order.OrderStatus) !== null && _d !== void 0 ? _d : "").toLowerCase();
            var isPaid = status_1 === "paid" || status_1 === "completed";
            if (!isPaid || (order === null || order === void 0 ? void 0 : order.isRefundedOrders)) {
                continue;
            }
            sub += Number((_e = order === null || order === void 0 ? void 0 : order.subtotal) !== null && _e !== void 0 ? _e : 0);
            com += Number((_f = order === null || order === void 0 ? void 0 : order.commission) !== null && _f !== void 0 ? _f : 0);
        }
        return {
            paidOrdersTotalSubtotal: sub,
            paidOrdersTotalCommission: com,
            orderDetailsDisplayCurrency: displayCurrency,
        };
    }, [stReportsDisplayPayload, orders, useSTOrderDetailsDateRange, shopCurrency, stOrderDetailsTableLoading, searchPending]), paidOrdersTotalSubtotal = _45.paidOrdersTotalSubtotal, paidOrdersTotalCommission = _45.paidOrdersTotalCommission, orderDetailsDisplayCurrency = _45.orderDetailsDisplayCurrency;
    useEffect(function () {
        var filterTable = salesOrderSearchText.subscribe(function (data) {
            var _a, _b, _c;
            if (useSTOrderDetailsDateRange) {
                if (data.orderTab === STOrderDetailsListTab) {
                    setSearchInputText((_a = data.searchText) !== null && _a !== void 0 ? _a : "");
                }
                return;
            }
            if (data.orderTab === "All") {
                setSearchInputText((_b = data.searchText) !== null && _b !== void 0 ? _b : "");
                var query_1 = String((_c = data.searchText) !== null && _c !== void 0 ? _c : "").toLowerCase();
                var filteredOrders = __spreadArray([], filtered, true).filter(function (order) {
                    var _a, _b, _c, _d, _e;
                    return ((order === null || order === void 0 ? void 0 : order.CustomerName) && ((_b = (_a = order === null || order === void 0 ? void 0 : order.CustomerName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(query_1))) ||
                        ((_e = ((order === null || order === void 0 ? void 0 : order.orderNumber) != "0" ? (_c = order === null || order === void 0 ? void 0 : order.orderNumber) !== null && _c !== void 0 ? _c : "" : (_d = order === null || order === void 0 ? void 0 : order.orderName) !== null && _d !== void 0 ? _d : "").toLowerCase()) === null || _e === void 0 ? void 0 : _e.includes(query_1));
                });
                setOrders(filteredOrders);
            }
        });
        return function () { return filterTable.unsubscribe(); };
    }, [filtered, useSTOrderDetailsDateRange, STOrderDetailsListTab]);
    var refundColumnVisibility = (_5 = props === null || props === void 0 ? void 0 : props.refundColumnVisibility) !== null && _5 !== void 0 ? _5 : {};
    var isRefundCol = function (key) { return refundColumnVisibility[key] !== false; };
    var RefundHeaderNames = [
        {
            label: t("refundOrders_column1"),
            hidden: !isRefundCol("refundId"),
            inlineCSS: { flex: 1, minWidth: "72px" },
        },
        {
            label: t("refundOrders_column2"),
            hidden: !isRefundCol("createdDate"),
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "88px" },
        },
        {
            label: t("refundOrders_column3"),
            hidden: !isRefundCol("orderNo"),
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "88px" },
        },
        {
            label: t("refundOrders_column5") + "(" + shopCurrency + ")",
            hidden: !isRefundCol("commission"),
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "88px" },
        },
        {
            label: t("refundOrders_column6") + "(" + shopCurrency + ")",
            hidden: !isRefundCol("teamManagerCommission"),
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "120px" },
        },
        {
            label: t("refundOrders_column8") + "(" + shopCurrency + ")",
            hidden: !isRefundCol("refundSubTotal"),
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "100px" },
        },
        {
            label: t("refundOrders_column9"),
            hidden: !isRefundCol("orderStatus"),
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "88px" },
        },
        {
            label: t("refundOrders_column10"),
            hidden: !isRefundCol("salesMethod"),
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "100px" },
        },
    ];
    var HeaderSalesNames = [
        {
            label: t("yourSales_table1Column1"),
            hidden: ((_6 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _6 === void 0 ? void 0 : _6.orderNumber) === false,
            inlineCSS: { flex: 1, minWidth: "60px" },
        },
        {
            label: t("draftOrder_CustName"),
            hidden: ((_7 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _7 === void 0 ? void 0 : _7.customerName) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
        },
        {
            label: t("yourSales_table1Column2"),
            hidden: ((_8 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _8 === void 0 ? void 0 : _8.orderDate) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
        },
        {
            label: t("yourSales_PaidOrders_PaidDate"),
            hidden: ((_9 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _9 === void 0 ? void 0 : _9.orderPaidDate) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
        },
        {
            label: t("yourSales_table1Column4"),
            hidden: ((_10 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _10 === void 0 ? void 0 : _10.subtotal) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
        },
        {
            label: t("yourSales_table1Column5"),
            hidden: ((_11 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _11 === void 0 ? void 0 : _11.commission) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
        },
        {
            label: t("salesDetailsHeader_Company"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || ((_12 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _12 === void 0 ? void 0 : _12.companyName) === false,
            inlineCSS: { flex: 1, minWidth: "60px" },
        },
        {
            label: t("salesDetailsHeader_Location"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || ((_13 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _13 === void 0 ? void 0 : _13.companyLocation) === false,
            inlineCSS: { flex: 1, minWidth: "60px" },
        },
        {
            label: t("customerInvoice_OrderType"),
            hidden: ((_14 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _14 === void 0 ? void 0 : _14.salesMethod) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "105px" },
        },
        {
            label: t("stReports_col_fulfilmentStatus"),
            hidden: ((_15 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _15 === void 0 ? void 0 : _15.fulfilmentStatus) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "90px" },
        },
        {
            label: t("stReports_col_orderStatus"),
            hidden: ((_16 = props === null || props === void 0 ? void 0 : props.columnVisibility) === null || _16 === void 0 ? void 0 : _16.status) === false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "80px" },
        },
        {
            label: t("yourSales_Action"),
            hidden: false,
            inlineCSS: { textAlign: "center", flex: 1, minWidth: "56px" },
        },
    ];
    var tableHeaderNames = isRefundedListTab ? RefundHeaderNames : HeaderSalesNames;
    var getPrintOrderDetails = function (item) { var _a; return (_a = buildPrintInvoicesBySalesRepUrl(item)) !== null && _a !== void 0 ? _a : ""; };
    var handleRefundOrderNoClick = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var params, refundDataResponse, lineItems, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    params = resolveRefundOrderDetailRequestParams(item, stReportsDisplayPayload);
                    if (!params) {
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                        return [2 /*return*/];
                    }
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(refundOrderData(params))];
                case 1:
                    refundDataResponse = _b.sent();
                    if (!refundDataResponse) {
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                        return [2 /*return*/];
                    }
                    lineItems = (_a = refundDataResponse === null || refundDataResponse === void 0 ? void 0 : refundDataResponse.refunds) === null || _a === void 0 ? void 0 : _a.refund_line_items;
                    if (Array.isArray(lineItems) && lineItems.length > 0) {
                        setAllOrdersRefundProducts(lineItems);
                        setAllOrdersDetailKind(OrderRowDetailKind.Refund);
                        return [2 /*return*/];
                    }
                    setAlertErrorMsg({ msg: t("noRefundOrderProduct"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _b.sent();
                    logClientRuntimeError("OrdersTableBL.handleRefundOrderNoClick", error_4);
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 3:
                    isLoading.next(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleMenuClick = function (event, order) {
        sharedHandleMenuClick(event, order, menuAnchorEl, selectedOrder, setMenuAnchorEl, setSelectedOrder);
    };
    var handleSendInvoice = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sharedHandleSendInvoice(selectedOrder, dispatch, setMenuAnchorEl, setSelectedOrder)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDuplicateOrder = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sharedHandleDuplicateOrder(selectedOrder, orders, dispatch, setMenuAnchorEl, setSelectedOrder)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handlePrintFromMenu = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sharedHandlePrintFromMenu(selectedOrder, setMenuAnchorEl, setSelectedOrder, setPrintInvoiceData, setOpenPrintInvoiceDialog)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var runEditDraftForRow = function (orderToProcess) { return __awaiter(_this, void 0, void 0, function () {
        var draftOrderDetailsResponse, b2bCompany, isB2BOrder, isB2BFeatureEnabled, b2BTabIndex, update_ActiveTab_InReduxStore, update_ActiveTab_InReduxStore, error_5;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(orderToProcess === null || orderToProcess === void 0 ? void 0 : orderToProcess.OrderId)) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(draftOrderDetails({ order_id: orderToProcess.OrderId }, EDIT_ORDER_FLAG))];
                case 2:
                    draftOrderDetailsResponse = _b.sent();
                    if (draftOrderDetailsResponse &&
                        draftOrderDetailsResponse.draftOrder &&
                        Object.keys(draftOrderDetailsResponse.draftOrder).length > 0 &&
                        draftOrderDetailsResponse.ProductDetails &&
                        draftOrderDetailsResponse.ProductDetails.length > 0) {
                        b2bCompany = (_a = draftOrderDetailsResponse.draftOrder) === null || _a === void 0 ? void 0 : _a.b2bCompany;
                        isB2BOrder = ((b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.id) && (b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.location_id)) || ((orderToProcess === null || orderToProcess === void 0 ? void 0 : orderToProcess.B2BCompanyName) && (orderToProcess === null || orderToProcess === void 0 ? void 0 : orderToProcess.B2BLocationName));
                        if (isB2BOrder) {
                            isB2BFeatureEnabled = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder;
                            if (isB2BFeatureEnabled) {
                                b2BTabIndex = calculateB2BTabIndex(selectFeatures);
                                update_ActiveTab_InReduxStore = {
                                    payload: { activeTabIndex: b2BTabIndex, actionEvent: EDIT_ORDER_FLAG },
                                    type: SalesRepDataActionType.ACTIVE_TAB,
                                };
                                dispatch(update_ActiveTab_InReduxStore);
                            }
                        }
                        else {
                            update_ActiveTab_InReduxStore = {
                                payload: { activeTabIndex: 1, actionEvent: EDIT_ORDER_FLAG },
                                type: SalesRepDataActionType.ACTIVE_TAB,
                            };
                            dispatch(update_ActiveTab_InReduxStore);
                        }
                    }
                    isLoading.next(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _b.sent();
                    logClientRuntimeError("OrdersTableBL.runEditDraftForRow", error_5);
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    isLoading.next(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleEditDraft = function () { return __awaiter(_this, void 0, void 0, function () {
        var orderToProcess;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    orderToProcess = selectedOrder;
                    handleMenuClose(setMenuAnchorEl, setSelectedOrder);
                    return [4 /*yield*/, runEditDraftForRow(orderToProcess)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAllOrdersDraftEdit = function () { return __awaiter(_this, void 0, void 0, function () {
        var row;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    row = allOrdersDraftSourceRow;
                    closeAllOrdersDetailDialogs();
                    return [4 /*yield*/, runEditDraftForRow(row)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAllOrdersDraftDuplicate = function () { return __awaiter(_this, void 0, void 0, function () {
        var client, row;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = allOrdersDraftClient;
                    row = allOrdersDraftSourceRow;
                    if (!client) {
                        return [2 /*return*/];
                    }
                    closeAllOrdersDetailDialogs();
                    return [4 /*yield*/, handleDuplicateOrderFromDialog(client, (client === null || client === void 0 ? void 0 : client.id) || (client === null || client === void 0 ? void 0 : client.orderid) || (row === null || row === void 0 ? void 0 : row.OrderId), true, dispatch, setAlertErrorMsg, t)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAllOrdersDraftSendInvoice = function () { return __awaiter(_this, void 0, void 0, function () {
        var row, emailToUse, isB2BOrder, draftOrderDetailsResponse, error_6, params, sendInvoiceResponse, error_7;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    row = allOrdersDraftSourceRow;
                    if (!(row === null || row === void 0 ? void 0 : row.OrderId)) {
                        return [2 /*return*/];
                    }
                    emailToUse = row.CustomerEmail || "";
                    isB2BOrder = (row === null || row === void 0 ? void 0 : row.B2BCompanyName) && (row === null || row === void 0 ? void 0 : row.B2BLocationName);
                    if (!(isB2BOrder && !emailToUse)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(draftOrderDetails({ order_id: row.OrderId }, ""))];
                case 2:
                    draftOrderDetailsResponse = _b.sent();
                    if (draftOrderDetailsResponse === null || draftOrderDetailsResponse === void 0 ? void 0 : draftOrderDetailsResponse.draftOrder) {
                        emailToUse = draftOrderDetailsResponse.draftOrder.email || ((_a = draftOrderDetailsResponse.draftOrder.customer) === null || _a === void 0 ? void 0 : _a.email) || "";
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_6 = _b.sent();
                    logClientRuntimeError("OrdersTableBL.handleAllOrdersDraftSendInvoice.draftEmail", error_6);
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    isLoading.next(true);
                    params = { orderid: row.OrderId, emailid: emailToUse };
                    return [4 /*yield*/, dispatch(sendInvoiceData(params))];
                case 5:
                    sendInvoiceResponse = _b.sent();
                    if (sendInvoiceResponse) {
                        setAlertErrorMsg({ msg: t("sendInvoice_successMsg"), open: true, severity: "success" });
                    }
                    isLoading.next(false);
                    return [3 /*break*/, 7];
                case 6:
                    error_7 = _b.sent();
                    logClientRuntimeError("OrdersTableBL.handleAllOrdersDraftSendInvoice", error_7);
                    setAlertErrorMsg({ msg: t("onSuccessInvoiceFailedMsg"), open: true, severity: "error" });
                    isLoading.next(false);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleAllOrdersDraftDelete = function () {
        var row = allOrdersDraftSourceRow;
        if (!row) {
            return;
        }
        closeAllOrdersDetailDialogs();
        setSelectedOrder(row);
        setDeleteConfirmation(true);
    };
    var handleDeleteDraft = function () {
        // Close the menu but keep selectedOrder for the delete confirmation
        setMenuAnchorEl(null);
        setDeleteConfirmation(true);
    };
    var confirmDeleteDraft = function () { return __awaiter(_this, void 0, void 0, function () {
        var orderIdToDelete_1, deleteInvoiceResponse, updatedOrders, updatedFiltered, filteredOrders, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedOrder) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setDeleteInvoiceFlag(true);
                    orderIdToDelete_1 = selectedOrder.OrderId;
                    return [4 /*yield*/, dispatch(deleteInvoiceData(orderIdToDelete_1))];
                case 2:
                    deleteInvoiceResponse = _a.sent();
                    // Check if delete was successful - response should be truthy and not false
                    if (deleteInvoiceResponse && deleteInvoiceResponse !== false) {
                        updatedOrders = orders.filter(function (order) { return String(order.OrderId) !== String(orderIdToDelete_1); });
                        updatedFiltered = filtered.filter(function (order) { return String(order.OrderId) !== String(orderIdToDelete_1); });
                        // Apply search filter if active
                        if (searchInputText && searchInputText.trim() !== "") {
                            filteredOrders = updatedOrders === null || updatedOrders === void 0 ? void 0 : updatedOrders.filter(function (order) {
                                var _a, _b, _c, _d, _e;
                                return ((order === null || order === void 0 ? void 0 : order.CustomerName) && ((_b = (_a = order === null || order === void 0 ? void 0 : order.CustomerName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchInputText === null || searchInputText === void 0 ? void 0 : searchInputText.toLowerCase()))) ||
                                    ((_e = ((order === null || order === void 0 ? void 0 : order.orderNumber) != "0" ? (_c = order === null || order === void 0 ? void 0 : order.orderNumber) !== null && _c !== void 0 ? _c : "" : (_d = order === null || order === void 0 ? void 0 : order.orderName) !== null && _d !== void 0 ? _d : "").toLowerCase()) === null || _e === void 0 ? void 0 : _e.includes(searchInputText === null || searchInputText === void 0 ? void 0 : searchInputText.toLowerCase()));
                            });
                            setOrders(filteredOrders);
                        }
                        else {
                            setOrders(updatedOrders);
                        }
                        setFiltered(updatedFiltered);
                        // The deleteInvoiceData action also updates Redux state (draftOrderData and ordersData.draftOrdersDetails)
                        // The useEffect hook watching ordersData will sync the state, but we've already updated optimistically
                        setDeleteConfirmation(false);
                        setSelectedOrder(null);
                    }
                    else {
                        // If delete failed, show error
                        setAlertErrorMsg({ msg: t("deleteInvoice_FailedMsg"), open: true, severity: "error" });
                    }
                    setDeleteInvoiceFlag(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_8 = _a.sent();
                    logClientRuntimeError("OrdersTableBL.confirmDeleteDraft", error_8);
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    setDeleteInvoiceFlag(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var cancelDeleteDraft = function () {
        setDeleteConfirmation(false);
        setSelectedOrder(null);
    };
    var parseDate = function (dateStr) {
        var parsed = parseDisplayDateValue(dateStr);
        if (!parsed) {
            throw new Error("Invalid date format");
        }
        return parsed;
    };
    var handleSort = function (ordersArray) {
        var ordersData = Array.isArray(ordersArray) ? __spreadArray([], ordersArray, true) : [];
        ordersData.sort(function (a, b) {
            if ((a === null || a === void 0 ? void 0 : a.orderDate) && (b === null || b === void 0 ? void 0 : b.orderDate)) {
                try {
                    var dateA = parseDate(String(a.orderDate));
                    var dateB = parseDate(String(b.orderDate));
                    return dateB.getTime() - dateA.getTime();
                }
                catch (_a) {
                    return 0;
                }
            }
            return 0;
        });
        return ordersData;
    };
    return {
        shopName: shopName,
        getPrintOrderDetails: getPrintOrderDetails,
        orderesLoading: orderesLoading,
        orders: ordersForDisplay,
        HeaderSalesNames: tableHeaderNames,
        isRefundedListTab: isRefundedListTab,
        isRefundCol: isRefundCol,
        handleRefundOrderNoClick: handleRefundOrderNoClick,
        shopCurrency: shopCurrency,
        currency: currency,
        handleSort: handleSort,
        selectFeatures: selectFeatures,
        openPrintInvoiceDialog: openPrintInvoiceDialog,
        setOpenPrintInvoiceDialog: setOpenPrintInvoiceDialog,
        printInvoiceData: printInvoiceData,
        handlePrintInvoiceClick: function (item) { return handlePrintInvoiceClick(item, setPrintInvoiceData, setOpenPrintInvoiceDialog); },
        menuAnchorEl: menuAnchorEl,
        selectedOrder: selectedOrder,
        handleMenuClick: handleMenuClick,
        handleMenuClose: function () { return handleMenuClose(setMenuAnchorEl, setSelectedOrder); },
        handleSendInvoice: handleSendInvoice,
        handleDuplicateOrder: handleDuplicateOrder,
        handlePrintFromMenu: handlePrintFromMenu,
        handleEditDraft: handleEditDraft,
        handleDeleteDraft: handleDeleteDraft,
        deleteConfirmation: deleteConfirmation,
        deleteInvoiceFlag: deleteInvoiceFlag,
        confirmDeleteDraft: confirmDeleteDraft,
        cancelDeleteDraft: cancelDeleteDraft,
        alertErrorMsg: alertErrorMsg,
        handleAlertMsgClose: handleAlertMsgClose,
        handleAllOrdersOrderNumberClick: handleAllOrdersOrderNumberClick,
        closeAllOrdersDetailDialogs: closeAllOrdersDetailDialogs,
        allOrdersDetailKind: allOrdersDetailKind,
        allOrdersStandardProducts: allOrdersStandardProducts,
        allOrdersStandardClient: allOrdersStandardClient,
        allOrdersDraftProducts: allOrdersDraftProducts,
        allOrdersDraftClient: allOrdersDraftClient,
        allOrdersRefundProducts: allOrdersRefundProducts,
        allOrdersStandardMoreActionsMode: allOrdersStandardMoreActionsMode,
        handleAllOrdersStandardDuplicate: handleAllOrdersStandardDuplicate,
        handleAllOrdersStandardPrint: handleAllOrdersStandardPrint,
        allOrdersStandardSourceRow: allOrdersStandardSourceRow,
        allOrdersDraftSourceRow: allOrdersDraftSourceRow,
        handleAllOrdersDraftEdit: handleAllOrdersDraftEdit,
        handleAllOrdersDraftDuplicate: handleAllOrdersDraftDuplicate,
        handleAllOrdersDraftSendInvoice: handleAllOrdersDraftSendInvoice,
        handleAllOrdersDraftDelete: handleAllOrdersDraftDelete,
        STOrderDetailsPage: STOrderDetailsPage,
        STOrderDetailsRowsPerPage: STOrderDetailsRowsPerPage,
        STOrderDetailsTotalRowCount: STOrderDetailsTotalRowCount,
        showSTOrderDetailsPagination: useSTOrderDetailsDateRange && STOrderDetailsTotalRowCount > 0 && !searchPending && (!hasDebouncedSearch || searchResultsCommitted),
        handleSTOrderDetailsPageChange: handleSTOrderDetailsPageChange,
        handleSTOrderDetailsRowsPerPageChange: handleSTOrderDetailsRowsPerPageChange,
        STOrderDetailsRowsPerPageOptions: ST_ORDER_DETAILS_ROWS_PER_PAGE_OPTIONS,
        paidOrdersTotalSubtotal: paidOrdersTotalSubtotal,
        paidOrdersTotalCommission: paidOrdersTotalCommission,
        orderDetailsDisplayCurrency: orderDetailsDisplayCurrency,
        noDataForSelectedPeriod: noDataForSelectedPeriod,
        searchInputText: searchInputText,
        handleSearchInputChange: handleSearchInputChange,
        handleSearchSubmit: handleSearchSubmit,
        useSTOrderDetailsDateRange: useSTOrderDetailsDateRange,
        showStOrderDetailsTableLoader: showStOrderDetailsTableLoader,
        showStOrderDetailsTableEmpty: showStOrderDetailsTableEmpty,
        isStOrderDetailsGridPending: isStOrderDetailsGridPending,
    };
}
export function CssConstantObjects() {
    var ST_OrdersTabs = {
        ".Mui-selected >.ST_TabLabel": {
            color: "black !important",
            backgroundColor: "#D0E3F3",
            borderRadius: "6px",
            padding: "5px 15px",
            fontSize: "13px",
            fontWeight: 600,
        },
        ".MuiButtonBase-root": {
            textTransform: "none",
            margin: "4px",
            borderRadius: "20px",
        },
        ".MuiButtonBase-root:not(.Mui-selected):hover .ST_TabLabel": {
            color: "#1976d2 !important",
        },
    };
    return { ST_OrdersTabs: ST_OrdersTabs };
}
